import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetNotificationsByAssociationId } from '../selectors/notifications';

import UserFaces from './user-faces';
import NotificationsBubble from 'components/NotificationsBubble';

class MessageThreadCTA extends PureComponent {
    render() {
        if (!this.props.replies) {
            return null;
        }

        return (
            <div className="message-thread-cta" onClick={this.props.onClick}>
                {
                    this.props.repliers.length ? (
                        <UserFaces users={this.props.repliers} size="xsmall" />
                    ) : null
                }

                { this.props.replies } repl{ this.props.replies > 1 ? 'ies' : 'y' }

                {
                    this.props.hasNotifications ? <NotificationsBubble count={1} typeDot={true}  /> : null
                }
            </div>
        );
    }
}

const makeMapStateToProps = () => {
    const getNotificationsByAssociationId = makeGetNotificationsByAssociationId();

    return ({ notifications }, ownProps) => ({
        hasNotifications: Boolean(getNotificationsByAssociationId(notifications.items, ownProps.id).length)
    });
}

export default connect(makeMapStateToProps)(MessageThreadCTA);
